import React 				from 'react';
import ReactDOM 			from 'react-dom';
import BLComponent			from '../../core/_BLComponent.jsx';

import DragDropUpload 		from '../../common/_DragDropUpload.jsx';

export default class ImportXMLModalBody extends BLComponent 
{
	
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 
		this.state = {
			systemProgress: 0
		}
	}
	componentWillUnmount() 
	{
		this.setState = (state,callback)=>{
        	return;
    	};
	}


	getModalPageType(curStep, fileOption)
	{
		if (curStep == 0) return 0;
		else if (curStep > 0 ) 
		{
			if (fileOption == 0) 
				return curStep;
			else 
				return curStep+1;
		}
		return 0;
	}

	render()
	{

		const {curStep, fileOption, showError} = this.props.data;
		const modalPageType = this.getModalPageType(curStep, fileOption);
		if (showError) {
			return (
				<section className="personal-inventory__part-out-modal-body">
					{this.renderImportError()}
				</section>
			);
		}
		else
		{
			return (
				<section className="personal-inventory__part-out-modal-body">

					{(modalPageType == 0)&&this.renderMainPage()}
					{(modalPageType == 1)&&this.renderFileFormatInfoPage()}
					{(modalPageType == 2)&&this.renderUploadPage()}
					{(modalPageType == 3)&&this.renderImportTypePage()}
					{(modalPageType == 4)&&this.renderUploadStatusPage()}
					{(modalPageType == 5)&&this.renderUploadCompletePage()}

				</section>
			);
		}
	}

	renderMainPage()
	{

		return (
			<div>
				<div className="text--bold">
					Where is your list from?
				</div>
				<div className="l-margin-top l-full-width">
					Please choose from the following options:
				</div>
				<div className="l-margin-top l-full-width">
					<button className="btn l-full-width" onClick={()=>this.props.func.selectFileOption(0)}>Custom CSV or XML file</button>
				</div>
				<div className="l-margin-top--sm">
					<button className="btn l-full-width" onClick={()=>this.props.func.selectFileOption(1)}>BrickLink XML</button>
				</div>
				<div className="l-margin-top--sm">
					<button className="btn l-full-width" onClick={()=>this.props.func.selectFileOption(2)}>Brickset CSV</button>
				</div>
				<div className="l-margin-top--sm">
					<button className="btn l-full-width" onClick={()=>this.props.func.selectFileOption(3)}>Rebrickable CSV</button>
				</div>

			</div>
		);
	}

	renderFileFormatInfoPage() {
		return (
			<div className="l-flex l-split l-column">
				<div>
					<div className="text--bold">
						Formatting
					</div>
					<div className="l-margin-top l-full-width">
						You can bulk upload an inventory with a CSV or XML file. Please make sure you are using all of the following attributes:
					</div>
					<div className="l-margin-top">
						<ul className="bullet-list">
							<li>ITEMTYPE</li>
							<li>ITEMID</li>
							<li>CONDITION</li>
							<li>SUBCONDITION (Sets only)</li>
							<li>COLOR (0 for sets, minifigures, books, catalogs, and most gear items)</li>
							<li>QTY</li>
						</ul>
					</div>
					{this.renderHelpArticleInfoBox()}
					</div>
				<div className="l-margin-bottom--xl" style={{height:"30px"}}>
					&nbsp;		
				</div>
			</div>
		)
	}	

	renderUploadPage() {
		const {fileImported, fileSizeError }= this.props.data;
		return(
			<div>
				<div>
					<DragDropUpload classes={"l-pad-y--xl personal-inventory__bg--white"} type="simple" accept=".csv,.xml" onDropFiles={(files, cb)=>this.uploadXmlFile(files, cb)}>
							<div className="text--center l-margin-top">
								<div>
									<img style={{width:"140px", height:"140px"}} src={"//" + blapp.config.getHost( "static2" ) + "/img/personal-inventory/xmlUpload.png"}/>
								</div>
								
								<div className="text--note l-margin-top--sm">Click here or drag and drop to upload your file.</div>
								<div className="text--note l-margin-top--sm">File size limit: 1MB</div>
								{(fileSizeError)&&
								<div className="text--note l-margin-top personal-inventory__info-box personal-inventory__info-box--red">
									<span className="text--primaryred l-margin-right--sm"><i className="fa-solid fa-triangle-exclamation"></i></span>
									Please choose a file 1MB or smaller.
								</div>}
							</div>
					</DragDropUpload>
				</div>
				
			</div>
		)
	}

	renderImportTypePage() {
		
		const {importType, importingFileName, totalUploadQty, allowEmptyUpload} = this.props.data;

		return(
			<div>
				<div className="text--center l-margin-top--xl">
					<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fillRule="evenodd" clipRule="evenodd" d="M73.164 29.427 62.24 18.503a6.25 6.25 0 0 0-4.415-1.836H31.25C27.8 16.68 25 19.48 25 22.93v54.167c0 3.45 2.8 6.25 6.25 6.25h37.5c3.45 0 6.25-2.8 6.25-6.25V33.855a6.28 6.28 0 0 0-1.836-4.428zm-4.921 3.92h-9.909v-9.91l9.909 9.91zM31.25 22.93v54.166h37.5v-37.5H55.208a3.118 3.118 0 0 1-3.125-3.125V22.93H31.25zM34 45h32v3H34v-3zm32 5H34v3h32v-3zm-32 5h32v3H34v-3zm32 5H34v3h32v-3zm-32 5h32v3H34v-3zm32 5H34v3h32v-3z" fill="#0A1E32"/>
					</svg>
					<div>
						{importingFileName}
					</div>
					{ ( (totalUploadQty > 0) || (allowEmptyUpload == true)) &&
						<div className="l-margin-top">
							<div className="l-inline-block l-margin-bottom">
								<div className="l-flex">
									<div className="l-margin-right l-flex"><input type="radio" className="radio-group__item" name="importType" value={0} checked={(importType==1)?true:false} onChange={()=>this.setImportType(1)}/></div><div>Add to collection</div>
								</div>
								<div className="l-flex">
									<div className="l-margin-right l-flex"><input type="radio" className="radio-group__item" name="importType" value={1} checked={(importType==2)?true:false} onChange={()=>this.setImportType(2)}/></div><div>Replace collection</div>
								</div>
							</div>
						</div>
					}
					{ ( (totalUploadQty == 0) && (allowEmptyUpload == false) )  &&
						this.renderEmptyFileBox()
					}
					{(importType==2)&&this.renderWarningArticleInfoBox()}
				</div>
				
			</div>
		)
	}

	updateSystemProress() {
		let systemProgress = this.state.systemProgress;
		if (systemProgress < 100) 
		{
			systemProgress = systemProgress + 25;
			this.setState({"systemProgress":systemProgress});
		}
	}

	renderUploadStatusPage() {
		const progressUploading = this.props.data.progressUploading;
		let curProg = this.getProgressStep(progressUploading);

		if (progressUploading == 1) 
		{
			curProg = this.state.systemProgress;
			
			setTimeout( function () { this.updateSystemProress( ) }.bind( this ), 1000 );
			
		}
		return(
			<div className="l-margin-top--xxl">
				<div className="text--center personal-inventory__uploading-container l-margin-bottom--xl">
					<div className="margin-top--xl personal-inventory__uploading-progress-box">
						<div className={"margin-top--xl personal-inventory__uploading-progress--" + curProg}></div>
						{(curProg == 25)&&<div className=" personal-inventory__uploading-cut-25"></div>}
						<div style={{marginTop:"15px"}}>
							<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fillRule="evenodd" clipRule="evenodd" d="M73.164 29.427 62.24 18.503a6.25 6.25 0 0 0-4.415-1.836H31.25C27.8 16.68 25 19.48 25 22.93v54.167c0 3.45 2.8 6.25 6.25 6.25h37.5c3.45 0 6.25-2.8 6.25-6.25V33.855a6.28 6.28 0 0 0-1.836-4.428zm-4.921 3.92h-9.909v-9.91l9.909 9.91zM31.25 22.93v54.166h37.5v-37.5H55.208a3.118 3.118 0 0 1-3.125-3.125V22.93H31.25zM34 45h32v3H34v-3zm32 5H34v3h32v-3zm-32 5h32v3H34v-3zm32 5H34v3h32v-3zm-32 5h32v3H34v-3zm32 5H34v3h32v-3z" fill="#0A1E32"/>
							</svg>
						</div>
					</div>
					
					<div style={{height:"140px"}}>&nbsp;</div>
				</div>
				{(curProg < 1)&&
					<div className="margin-top--xl margin-bottom--xxl text--center">Uploading your file...</div>
				}
				{(this.state.systemProgress > 0)&&
					<div className="margin-top--xl margin-bottom--xxl text--center">Upload complete! Processing file...</div>
				}
				<div className="l-margin-bottom--xl" style={{height:"60px"}}>&nbsp;</div>
				
			</div>
		)
	}

	getProgressStep(progress) {
		if (progress > 0) 
			if (progress < 0.25)
				return 0;
			else 
				if (progress < 0.5)
					return 25;
				else
					if (progress < 0.75) 
						return 50;
					else
						if (progress < 1)
							return 75;
						else
							return 100;
		else
			return 0;
	}


	renderUploadCompletePage() {
		const itemTypeList = {P:"Parts", B:"Books", M:"Minifigures", C:"Catalogs", S:"Sets", G:"Gear"};
		const {itemType, uploadError, uploadErrorMsg, importResult, totalUploadQty} = this.props.data;
		if ( (importResult == null ) && (!uploadError))
		{
			return null;
		}

		if (!uploadError)
		{
			const {totalItems, uploadedItems, resultCode, errorList} = importResult;

			if ( (totalItems == 0) && (uploadedItems == 0) && (totalUploadQty > 0) )
			{
				return(
					<div className="text--center">
						<div className="l-margin-top personal-inventory__error-modal-icon">
							<i className="fa-solid fa-triangle-exclamation"></i>
						</div>
						<div className="l-margin-top--xl">
							We were unable to import your file. 
						</div>
						<div>
							Please make sure it is properly formatted.
						</div>	
						{this.renderHelpArticleInfoBox()}
						<div className="l-margin-bottom">&nbsp;</div>
					</div>
				)
			}
			else
			{
				return(
					<div className="text--center">
						<div>
							<div className="l-margin-top--xl">
								<div className="personal-inventory__circle-border">
								<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fillRule="evenodd" clipRule="evenodd" d="M73.164 29.427 62.24 18.503a6.25 6.25 0 0 0-4.415-1.836H31.25C27.8 16.68 25 19.48 25 22.93v54.167c0 3.45 2.8 6.25 6.25 6.25h37.5c3.45 0 6.25-2.8 6.25-6.25V33.855a6.28 6.28 0 0 0-1.836-4.428zm-4.921 3.92h-9.909v-9.91l9.909 9.91zM31.25 77.096V22.93h20.833V36.47a3.118 3.118 0 0 0 3.125 3.125H68.75v37.5h-37.5z" fill="#0A871F"/>
									<path fillRule="evenodd" clipRule="evenodd" d="M47.62 62.577 58.3 51.898a.929.929 0 0 0 0-1.313l-1.314-1.313a.929.929 0 0 0-1.313 0l-8.709 8.709-4.066-4.066a.929.929 0 0 0-1.313 0l-1.313 1.313a.928.928 0 0 0 0 1.313l6.036 6.036a.928.928 0 0 0 1.313 0z" fill="#0A871F"/>
								</svg>
								</div>
							</div>
							<div className="l-margin-top--xl">
								Uploading complete!
							</div>
							<div className="text--small">
								<div className="l-margin-bottom--xl">
									{uploadedItems} out of {totalItems} item{(totalItems>1)?"s":""} successfully added to My Collection.
								</div>
							</div>
						</div>
						<div className="l-margin-bottom--xl" style={{height:"60px"}}>&nbsp;</div>
					</div>
				)
			}
		}
		else
		{
			return(
				<div>
					<div>
						{uploadErrorMsg}
					</div>
					
				</div>
			)
		}	
	}

	renderImportError() {
		const importResult = this.props.data.importResult;
		const errorList = importResult.errorList;
		const errors = errorList.map( (error, idx)=>{
			return (
				<div className="l-flex l-margin-bottom text--small" key={"errorlist-" + idx}>
					<div className="text--bold l-margin-right--sm text--no-wrap">{error.itemNo}{(error.color!=null)?","+error.color:""}:</div>
					<div>{error.errorMessage}</div>
				</div>
			)
		} );

		return (
			<div className="personal-inventory__error-modal">
				<div className="l-margin-bottom">The following items had errors and were not imported:</div>
				{errors}
				{this.renderHelpArticleInfoBox()}
				<div className="l-margin-bottom--xl" style={{height:"30px"}}>&nbsp;</div>
			</div>

		)
	}

	renderEmptyFileBox() {
		return (
			<div className="l-flex l-margin-bottom l-margin-top--xl personal-inventory__info-box personal-inventory__info-box--red">
				<div className="l-margin-right text--primaryred"><i className="fa-solid fa-triangle-exclamation"></i></div><div className="text--left">Your selected file is blank. Do you want to continue?</div>
			</div>
		)
	}

	renderHelpArticleInfoBox() {
		const helpArticleID = 2567;
		return (
			<div className="l-flex l-margin-bottom l-margin-top--xl personal-inventory__info-box personal-inventory__info-box--yellow">
				<div className="l-margin-right"><i className="fa-solid fa-circle-exclamation"></i></div><div className="text--small">Please visit <a href={"/help.asp?helpID=" + helpArticleID}>this Help Center article</a> to learn more about formatting your CSV or XML file for import.</div>
			</div>
		)
	}

	renderWarningArticleInfoBox() {
		return(
			<div className="l-flex l-margin-bottom personal-inventory__info-box personal-inventory__info-box--red">
				<div className="l-margin-right text--primaryred"><i className="fa-solid fa-triangle-exclamation"></i></div><div className="text--small text--left">Choosing this option will erase your entire current collection and replace it with the contents of your XML or CSV file.</div>
			</div>
		)
	}

	setImportType(type) {
		this.props.func.setImportType(type); 
	}

	uploadXmlFile(files, cb) {
		this.props.func.setFile(files, cb);	
	}

};

 

